import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopMembershipObjectAttributesFragment = { __typename: 'ShopMembershipObject', id: number, name: string, slug: string, description?: string | null | undefined, locale: string, contentRef?: string | null | undefined, renewalMessage?: string | null | undefined, termsUrl?: string | null | undefined, activationUrl?: string | null | undefined, meta?: { __typename: 'ShopMetaContentObject', title?: string | null | undefined, description?: string | null | undefined, keywords?: string | null | undefined } | null | undefined };

export type ShopMembershipDetailByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopMembershipDetailByIdQuery = { __typename: 'Query', shopMembership: { __typename: 'ShopMembershipObject', id: number, name: string, slug: string, description?: string | null | undefined, locale: string, contentRef?: string | null | undefined, renewalMessage?: string | null | undefined, termsUrl?: string | null | undefined, activationUrl?: string | null | undefined, meta?: { __typename: 'ShopMetaContentObject', title?: string | null | undefined, description?: string | null | undefined, keywords?: string | null | undefined } | null | undefined } };

export const ShopMembershipObjectAttributesFragmentDoc = gql`
    fragment ShopMembershipObjectAttributes on ShopMembershipObject {
  id
  name
  slug
  description
  locale
  contentRef
  renewalMessage
  termsUrl
  activationUrl
  meta {
    title
    description
    keywords
  }
}
    `;
export const ShopMembershipDetailByIdDocument = gql`
    query ShopMembershipDetailById($id: Int!, $locale: String!, $channelCode: String!) {
  shopMembership(id: $id, locale: $locale, channelCode: $channelCode) {
    ...ShopMembershipObjectAttributes
  }
}
    ${ShopMembershipObjectAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopMembershipDetailByIdGQL extends Apollo.Query<ShopMembershipDetailByIdQuery, ShopMembershipDetailByIdQueryVariables> {
    document = ShopMembershipDetailByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }